<template>
  <div class="bunny-player-wrapper">
    <div
      v-if="videoUrl"
      class="video-container"
      :style="{
        maxWidth: width ? `${width}px` : '100%',
        maxHeight: height ? `${height}px` : '100%'
      }"
    >
      <iframe
        :src="videoUrl"
        :title="bunnyVideo.title || 'Video Player'"
        loading="lazy"
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        allowfullscreen="true"
      />
    </div>
  </div>
</template>

<script>
import BunnyVideo from '@/models/BunnyVideo';

export default {
  name: 'BaseVideoBunnyPlayer',
  props: {
    bunnyVideo: {
      type: BunnyVideo,
      required: true
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  computed: {
    videoUrl() {
      const { guid } = this.bunnyVideo ?? {};
      const libraryId = process.env.VUE_APP_BUNNY_STREAM_LIBRARY_ID;

      if (!guid || !libraryId) return null;

      const params = new URLSearchParams({
        autoplay: false,
        loop: false,
        muted: false,
        preload: true,
        responsive: true
      });

      return `https://player.mediadelivery.net/embed/${libraryId}/${guid}?${params}`;
    }
  }
};
</script>

<style scoped>
.bunny-player-wrapper {
  display: flex;
}

.video-container {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}

.video-container iframe {
  border: 0;
  width: 100%;
  height: 100%;
}
</style>
